{
  "name": "@wix/cli-app",
  "description": "CLI tool for Wix apps",
  "version": "1.1.177",
  "author": "Amit Dahan",
  "dependencies": {
    "esbuild": "^0.25.0",
    "miniflare": "3.20241106.0",
    "vite": "6.2.4"
  },
  "devDependencies": {
    "@commander-js/extra-typings": "^13.0.0",
    "@types/lodash": "^4.17.16",
    "@types/mustache": "^4.2.5",
    "@types/react": "^18.3.3",
    "@types/semver": "^7.5.8",
    "@wix/ambassador-blocks-v1-application-structure": "^1.0.9",
    "@wix/ambassador-blocks-v1-blocks-app": "^1.0.88",
    "@wix/ambassador-cli-site-override-service-v1-site-override": "^1.0.12",
    "@wix/ambassador-ctp-app-cloud-backend-service-v1-app-cloud-backend-deployment": "^1.0.15",
    "@wix/ambassador-ctp-gradual-rollout-v1-app-config": "^1.0.82",
    "@wix/ambassador-devcenter-apps-v1-app-old": "^1.0.193",
    "@wix/app-cloud-uploader": "^1.18.0",
    "@wix/arm-client": "workspace:*",
    "@wix/bi-logger-dev-tools-data": "^1.169.0",
    "@wix/cli-app-definitions": "workspace:*",
    "@wix/cli-app-manifest": "workspace:*",
    "@wix/cli-app-platform-sdk": "workspace:*",
    "@wix/cli-auth": "workspace:*",
    "@wix/cli-blocks-editor-comm-api": "workspace:*",
    "@wix/cli-cloudflare-runtime": "workspace:*",
    "@wix/cli-command-contract": "workspace:*",
    "@wix/cli-core-definitions": "workspace:*",
    "@wix/cli-debug-log": "workspace:*",
    "@wix/cli-error": "workspace:*",
    "@wix/cli-error-reporting": "workspace:*",
    "@wix/cli-fs": "workspace:*",
    "@wix/cli-http-client": "workspace:*",
    "@wix/cli-http-client-react": "workspace:*",
    "@wix/cli-i18n": "workspace:*",
    "@wix/cli-miniflare": "workspace:*",
    "@wix/cli-panorama": "workspace:*",
    "@wix/cli-site-selector": "workspace:*",
    "@wix/cli-ssl": "workspace:*",
    "@wix/cli-telemetry": "workspace:*",
    "@wix/cli-telemetry-react": "workspace:*",
    "@wix/cli-test-overrides": "workspace:*",
    "@wix/cli-tunnel": "workspace:*",
    "@wix/cli-ui-kit": "workspace:*",
    "@wix/cli-user-config": "workspace:*",
    "@wix/dev-center-client": "workspace:*",
    "@wix/extensions-data-client": "workspace:*",
    "@wix/gena": "workspace:*",
    "@wix/metasite-manager-client": "workspace:*",
    "@wix/monitoring-buildtime": "^1.43.0",
    "@wix/package-manager": "workspace:*",
    "@wix/site-list-client": "workspace:*",
    "@wix/site-override-client": "workspace:*",
    "@wix/tsup-configs": "workspace:*",
    "@wix/user-browser": "workspace:*",
    "@wix/vite-optimize-backend-dependencies": "workspace:*",
    "@wix/vite-tsconfig-paths": "workspace:*",
    "chokidar": "^3.6.0",
    "commander": "^13.0.0",
    "es-module-lexer": "^1.5.4",
    "fast-equals": "^5.2.2",
    "globby": "^14.1.0",
    "http-proxy-3": "^1.21.0",
    "lodash": "^4.17.21",
    "magic-string": "^0.30.11",
    "minimatch": "^10.0.1",
    "mustache": "^4.2.0",
    "node-html-parser": "^6.1.13",
    "outdent": "^0.8.0",
    "p-retry": "^6.2.1",
    "p-wait-for": "^5.0.2",
    "react": "^18.3.1",
    "semver": "^7.6.3",
    "variant": "^3.0.0-dev.27",
    "vite-plugin-externalize-dependencies": "^1.0.1",
    "vite-plugin-externals": "^0.6.2",
    "zod": "^3.24.2",
    "zod-to-json-schema": "^3.24.3"
  },
  "engines": {
    "node": ">= 20.11.0"
  },
  "exports": {
    ".": "./build/index.js",
    "./client": {
      "types": "./client.d.ts"
    },
    "./internal/platform-sdk/*": "./build/platform-sdk/*.js",
    "./internal/cloudflare-runtime/*": "./build/cloudflare-runtime/*.js",
    "./internal/miniflare/*": "./build/miniflare/*.js",
    "./internal/component-hmr-wrapper": "./internal/component-hmr-wrapper.tsx",
    "./tsconfig.app.json": "./tsconfig.app.json",
    "./package.json": "./package.json"
  },
  "files": [
    "build",
    "schemas",
    "tsconfig.app.json",
    "client.d.ts",
    "internal",
    "templates"
  ],
  "homepage": "https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-cli/about-the-wix-cli-for-apps",
  "keywords": [
    "wix",
    "wix-cli"
  ],
  "peerDependencies": {
    "react": "^16.14 || ^17 || ^18",
    "react-dom": "^16.14 || ^17 || ^18",
    "typescript": ">=5.5.0 <5.9.0"
  },
  "peerDependenciesMeta": {
    "react-dom": {
      "optional": true
    }
  },
  "perfer": {
    "bundleSize": {
      "files": [
        {
          "glob": "./build/index.js",
          "maxSize": "460kb"
        }
      ]
    }
  },
  "publishConfig": {
    "registry": "https://registry.npmjs.org/",
    "access": "public",
    "versionBumpStrategy": "manual",
    "logLevel": "verbose"
  },
  "scripts": {
    "build": "run -T tsup && yarn generate-schemas",
    "build:watch": "run -T build:watch --filter='@wix/cli' --filter='@wix/cli-app'",
    "generate-schemas": "node build-scripts/generate-schemas.js",
    "test": "yarn workspace @wix/cli-app-spec run test",
    "test:watch": "yarn workspace @wix/cli-app-spec run test:watch",
    "typecheck": "run -T tsc --noEmit"
  },
  "sideEffects": false,
  "type": "module",
  "wix": {
    "artifact": {
      "groupId": "com.wixpress.npm",
      "artifactId": "wix-cli-app"
    },
    "validations": {
      "postBuild": [
        "typecheck"
      ]
    }
  }
}
